import { makeStyles } from '@material-ui/core/styles';

const borderGray = 'rgba(233, 235, 245, 1)';
const surfaceSoft = 'rgba(250, 250, 254, 1)';
const textTitle = 'rgba(43, 44, 53, 1)';
const textMid = 'rgba(95, 96, 113, 1)';
const textGreen = 'rgba(69, 101, 82, 1)';

const useStyles = makeStyles(() => ({
  /* ===== Root & section ===== */
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  section: {
    padding: 24,
    boxSizing: 'border-box',
    gap: 8,
    display: 'flex',
    flexDirection: 'column',
  },

  /* ===== Title ===== */
  title: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    color: textTitle,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
  },

  /* ===== Info panel ===== */
  infoPanel: {
    minHeight: 96,
    border: `1px solid ${borderGray}`,
    borderRadius: 8,
    boxSizing: 'border-box',
    background: surfaceSoft,
    padding: 24,
    display: 'flex',
    gap: 12,
    alignItems: 'flex-start',
  },
  icon: {
    height: 48,
    width: 48,
    flexShrink: 0,
  },
  infoTextCol: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    minWidth: 0,
    flex: 1,
  },

  subTitle: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '17px',
    color: textMid,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
  },
  noDataText: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    color: textMid,
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },

  /* ===== Records ===== */
  recordsWrap: {
    marginTop: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  recordItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  recordFileName: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '17px',
    color: textGreen,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
  },
  recordLabel: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '17px',
    color: textGreen,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
  },
  recordValue: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '17px',
    color: textGreen,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },

  /* ===================== Responsiveness ===================== */

  /* ≤1440px */
  '@media (max-width:1440px)': {
    section: { padding: 22 },
    infoPanel: { padding: 22, gap: 12 },
    icon: { height: 46, width: 46 },
    title: { fontSize: 13, lineHeight: '20px' },
    subTitle: { fontSize: 12, lineHeight: '16px' },
    noDataText: { fontSize: 13, lineHeight: '20px' },
  },

  /* ≤1280px */
  '@media (max-width:1280px)': {
    section: { padding: 20 },
    infoPanel: { padding: 20, gap: 10 },
    icon: { height: 44, width: 44 },
    title: { fontSize: 13 },
    subTitle: { fontSize: 12 },
    noDataText: { fontSize: 13 },
  },

  /* ≤1024px */
  '@media (max-width:1024px)': {
    section: { padding: 16 },
    infoPanel: {
      padding: 16,
      gap: 10,
      alignItems: 'flex-start',
    },
    icon: { height: 40, width: 40 },
    title: { fontSize: 12, lineHeight: '18px' },
    subTitle: { fontSize: 11, lineHeight: '16px' },
    noDataText: { fontSize: 12, lineHeight: '18px' },
    recordsWrap: { gap: 10, marginTop: 10 },
    recordFileName: { fontSize: 11, lineHeight: '16px' },
    recordLabel: { fontSize: 11, lineHeight: '16px' },
    recordValue: { fontSize: 12, lineHeight: '16px' },
  },
}));

export default useStyles;
